import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Search } from "react-bootstrap-table2-toolkit";
import moment from "moment";

// Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import { getActivityLogRounds } from "store/registrationdmin-history/actions";
import { isEmpty, size } from "lodash";
import "assets/scss/table.scss";

class MsgsList extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.state = {
      activitylogRounds: [],
      modal: false,
      deleteModal: false,
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
    };
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    const { onGetActivityLogRounds } = this.props;

    // Get 'id' from route params
    const id = this.props.match?.params?.id;
    const { user_id } = this.state;

    // 🧩 Log the values to confirm what’s being passed
    console.log("🟢 componentDidMount called");
    console.log("📦 Route param ID:", id);
    console.log("👤 User ID (from state):", user_id);

    if (id) {
      console.log("🚀 Calling onGetActivityLogRounds with:", { id, user_id });
      onGetActivityLogRounds(id, user_id);
    } else {
      console.error("❌ ID missing in the request.");
    }
  }

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  }

  componentDidUpdate(prevProps) {
    const { activitylogRounds } = this.props;
    if (
      !isEmpty(activitylogRounds) &&
      size(prevProps.activitylogRounds) !== size(activitylogRounds)
    ) {
      this.setState({ activitylogRounds: {}, isEdit: false });
    }
  }

  onPaginationPageChange = page => {
    if (
      this.node &&
      this.node.current &&
      this.node.current.props &&
      this.node.current.props.pagination &&
      this.node.current.props.pagination.options
    ) {
      this.node.current.props.pagination.options.onPageChange(page);
    }
  };

  formatFieldName(name) {
    if (!name) return "";
    return name.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase());
  }
  formatReadableValue = value => {
    try {
      const parsed = JSON.parse(value);

      if (typeof parsed === "object" && parsed !== null) {
        const {
          analyte,
          units,
          instrument,
          method,
          reagents,
          result,
          round_name,
          round_status,
          result_status,
          result_type,
        } = parsed;

        const readableParts = [];

        if (analyte)
          readableParts.push(
            `Analyte: ${this.props.analyteMap?.[analyte] || analyte}`
          );
        if (units)
          readableParts.push(`Units: ${this.props.unitMap?.[units] || units}`);
        if (instrument)
          readableParts.push(
            `Instrument: ${
              this.props.instrumentMap?.[instrument] || instrument
            }`
          );
        if (method)
          readableParts.push(
            `Method: ${this.props.methodMap?.[method] || method}`
          );
        if (reagents)
          readableParts.push(
            `Reagents: ${this.props.reagentsMap?.[reagents] || reagents}`
          );
        if (result) readableParts.push(`Result: ${result}`);
        if (round_status) readableParts.push(`Round Status: ${round_status}`);
        if (result_status)
          readableParts.push(`Result Status: ${result_status}`);
        if (result_type) readableParts.push(`Result Type: ${result_type}`);
        if (round_name) readableParts.push(`Round: ${round_name}`);

        return readableParts.join(", ");
      }

      return value;
    } catch (e) {
      return value;
    }
  };

  render() {
    const { SearchBar } = Search;
    const { activitylogRounds } = this.props;
    const { isEdit, deleteModal } = this.state;
    const pageOptions = {
      sizePerPage: 10,
      totalSize: activitylogRounds ? activitylogRounds.length : 0,
      custom: true,
    };
    const defaultSorted = [
      {
        dataField: "id",
        order: "desc",
      },
    ];
    const statusColors = {
      "Report Available": "purple",
    };

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title> History | Rounds</title>
          </MetaTags>
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="History" breadcrumbItem="Activity Log" />
            <Row>
              <Col lg="8" className="offset-lg-2">
                <Card className="mb-2 d-flex justify-content-center">
                  <CardBody>
                    {!isEmpty(this.props.activitylogRounds) &&
                      Object.values(
                        this.props.activitylogRounds
                          .filter(activity => {
                            const allowedResultStatuses = [
                              "saved",
                              "submit",
                              "resubmit",
                            ];
                            const allowedRoundStatus = "report available";

                            const status = activity.status?.toLowerCase() || "";
                            const newVal =
                              activity.new_value?.toLowerCase() || "";
                            const oldVal =
                              activity.old_value?.toLowerCase() || "";

                            // ✅ Only allow "report available" for rounds
                            const isRoundStatusChange =
                              status === allowedRoundStatus ||
                              newVal === allowedRoundStatus ||
                              oldVal === allowedRoundStatus;

                            // ✅ Only allow saved/submit/resubmit for results
                            const isResultStatusChange =
                              allowedResultStatuses.some(
                                s =>
                                  status.includes(s) ||
                                  activity.new_value
                                    ?.toLowerCase()
                                    ?.includes(s) ||
                                  activity.old_value?.toLowerCase()?.includes(s)
                              );

                            return isRoundStatusChange || isResultStatusChange;
                          })
                          .reduce((acc, log) => {
                            const key = `${
                              log.round_id
                            }-${log.status?.toLowerCase()}`;
                            if (!acc[key]) {
                              acc[key] = log;
                            } else {
                              const oldDate = new Date(
                                acc[key].date_of_updation ||
                                  acc[key].date_of_addition
                              );
                              const newDate = new Date(
                                log.date_of_updation || log.date_of_addition
                              );
                              if (newDate > oldDate) acc[key] = log;
                            }
                            return acc;
                          }, {})
                      ).map((activity, key) => {
                        const statusColor =
                          statusColors[activity.status] || "gray";

                        return (
                          <Card
                            key={"_card_" + key}
                            className="mb-2"
                            style={{
                              backgroundColor: "#f2f2f2",
                              borderLeft: `5px solid ${statusColor}`,
                            }}
                          >
                            <CardBody className="p-3">
                              <div style={{ marginBottom: "10px" }}>
                                <span style={{ fontWeight: "bold" }}>
                                  Round Status:
                                </span>
                                <span
                                  style={{
                                    color: statusColor,
                                    marginLeft: "10px",
                                  }}
                                >
                                  {activity.status}
                                </span>
                              </div>

                              <div style={{ marginBottom: "10px" }}>
                                <b>{activity.added_by}</b> changed status on{" "}
                                <b>
                                  {moment(
                                    activity.date_of_updation ||
                                      activity.date_of_addition
                                  ).format("DD-MMM-YY, h:mm A")}
                                </b>
                              </div>
                            </CardBody>
                          </Card>
                        );
                      })}

                    {isEmpty(this.props.activitylogRounds) && (
                      <Row>
                        <Col lg="12">
                          <div className=" mb-5">
                            <h5 className="text-uppercase">
                              No Comments exists.....
                            </h5>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

MsgsList.propTypes = {
  match: PropTypes.object,
  activitylogRounds: PropTypes.array,
  className: PropTypes.any,
  onGetActivityLogRounds: PropTypes.func,
  location: PropTypes.object,
  analyteMap: PropTypes.object,
  unitMap: PropTypes.object,
  instrumentMap: PropTypes.object,
  methodMap: PropTypes.object,
  reagentsMap: PropTypes.object,
};

const mapStateToProps = state => ({
  activitylogRounds: state.activitylogRounds.activitylogRounds,
  count: state.activitylogRounds.count,
  next: state.activitylogRounds.next,
  previous: state.activitylogRounds.previous,
  error: state.activitylogRounds.error,
});
const mapDispatchToProps = dispatch => ({
  onGetActivityLogRounds: (id, user_id) =>
    dispatch(getActivityLogRounds(id, user_id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MsgsList));

